import styled from 'styled-components';

export const CardsWrapper = styled.div`
    height: 235px; width: 80%;
    position: absolute;
    bottom: 25px; left: 10%;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
`;